export const LocalStorageKey = {
   agency: 'agency',
   agencyGroup: 'agencyGroup',
   autorisation: 'autorisation',
   back: 'back',
   campagne: 'campagne',
   commercial: 'commercial',
   cotation: 'cotation',
   CotationDialog: 'CotationDialog',
   cotationOrder: 'cotatioOrder',
   dataCotation: 'dataCotation',
   detailProject: 'detailProject',
   dispo: 'dispo',
   edit: 'edit',
   fee: 'fee',
   externalUsers: 'externalUsers',
   guid: 'guid',
   idChaineWithLogo: 'idChaineWithLogo',
   idOrder: 'idOrder',
   logo: 'logo',
   mail: 'mail',
   menu: 'menu',
   modeDaltonien: 'modeDaltonien',
   newCampagne: 'newCampagne',
   optionsByMode: 'optionsByMode',
   siren: 'siren',
   siret: 'siret',
   idAdClient: 'idAdClient',
   status: 'status',
   user: 'user',
   userRights: 'userRights',
   validateUsers: 'validateUsers',
   selectedSlotGroups: 'selectedSlotGroups',
   selectedSlots: 'selectedSlots',
   orderIdInModification: "orderIdInModification"
} as const;
